export default __webpack_public_path__ + "static/media/Jenny_Timur-682_websize.931b801b.jpg";